import { isGeneratedCodingPracticeTest1Enabled } from 'bundles/assignment-submission/FeatureFlags';
import GradingExperiments from 'bundles/epic/clients/Grading';
import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';
import type { Item } from 'bundles/learner-progress/types/Item';

/**
 * https://tools.coursera.org/epic/experiment/qsdyVjTDEfCp_w6fFr_gMQ
 *
 * Feature flag to temporary hide work-in-progress on the new Course Frame.
 * @returns true if the Course Frame is enabled.
 */
export const isCourseFrameEnabled = (computedItem?: Item): boolean => {
  // This isn't rolling back, needs to be cleaned up
  const isCourseFrameEpicEnabled = GradingExperiments.preview('isCourseFrameEnabled') === true;

  if (computedItem) {
    const { courseId, id: itemId, contentSummary } = computedItem;

    const isUngradedAssignment = contentSummary.typeName === 'ungradedAssignment';

    const isCodingPracticeTest1Enabled = isGeneratedCodingPracticeTest1Enabled(courseId, itemId);

    const useNewCodingPracticeExperience = !(isCodingPracticeTest1Enabled && isUngradedAssignment);

    return isCourseFrameEpicEnabled && useNewCodingPracticeExperience;
  } else {
    return isCourseFrameEpicEnabled;
  }
};

// new Date('Wed Aug 27 2025 15:30:00 GMT-0700 (Pacific Daylight Time)').getTime()
const TIME_ESTIMATES_ENROLLMENT_START_TIME = 1756333800000;

export const isEnrollmentAfterTimeEstimatesExperimentStarted = (enrollmentTime: number | undefined): boolean => {
  return typeof enrollmentTime === 'number' && enrollmentTime >= TIME_ESTIMATES_ENROLLMENT_START_TIME;
};

/**
 * https://tools.coursera.org/epic/experiment/vownu3yWEfCAfhJYNo68EQ
 *
 * A/B test to enable time estimates on the course outline.
 * @returns true if time estimates are enabled.
 */
export const isCourseOutlineTimeEstimatesEnabled = (courseEnrollmentTime: number | undefined): boolean => {
  return (
    isEnrollmentAfterTimeEstimatesExperimentStarted(courseEnrollmentTime) &&
    LceCourseExperienceExperiments.get('isCourseOutlineTimeEstimatesEnabled') === true
  );
};

/**
 * EPIC: https://tools.coursera.org/epic/experiment/DJASFX-NEfC-lAr_4rnFJw
 * @returns true if phase 3 should be shown in the UI.
 */
export const isCourseFramePhase3Enabled = (): boolean => {
  return LceCourseExperienceExperiments.get('isCourseFramePhase3Enabled') === true;
};
